import { connectBaseApi, createRpcMutation, createRpcQuery, teamClient } from "@racoon/api";

export const teamGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listTeams: createRpcQuery(build, teamClient, "listTeams", { providesTags: ["Team"] }),
    createTeam: createRpcMutation(build, teamClient, "createTeam", { invalidatesTags: ["Team"] }),
    updateTeam: createRpcMutation(build, teamClient, "updateTeam", { invalidatesTags: ["Team"] }),
    deleteTeam: createRpcMutation(build, teamClient, "deleteTeam", { invalidatesTags: ["Team"] }),
  }),
  overrideExisting: false,
});

export const {
  useListTeamsQuery,
  useLazyListTeamsQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
} = teamGrpc;
